"use client";
import { routes } from "@/utils/routes";
import { Button, Result } from "antd";
import Link from "next/link";

export default function NotFound() {
  return (
    <div className="font-bold h-screen flex items-center justify-center">
      <Result
        status="404"
        title="404"
        subTitle="Xin lỗi! Trang không tồn tại"
        className="customResult"
        extra={
          <Link href={routes.home}>
            <Button type="primary">Trở về trang chủ</Button>
          </Link>
        }
      />
    </div>
  );
}
